<script setup lang="ts">
import { Button } from '@toruslabs/vue-components/Button';
import { useAuthStore } from '../../store/authStore';
import { useClaimStore } from '../../store/claimStore';

import IconBack from '../../assets/claim/icon-back.svg';
import IconPolygonscan from '../../assets/claim/icon-polygonscan.svg';
import TickLightGreen from '../../assets/claim/tick-light-green.svg';

const authStore = useAuthStore();
const claimStore = useClaimStore();
const mocaIdName = claimStore.user.realmId || '';
const mocaIdImg = claimStore.user.idImageUrl || '';

async function logout() {
    await authStore.logout();
    claimStore.reset();
}

</script>

<template>
    <Button class="mb-2 !text-moca-gray-3 !text-sm !font-semibold !bg-moca-transparent !px-0" @on-click="logout">
        <img :src="IconBack" class="w-4" />
        <p>Back</p>
    </Button>
    <div class="flex flex-col items-center justify-center gap-4">
        <div class="text-lg text-moca-green-2 font-bold">
            Successfully claimed your Moca ID
            <img class="inline-block" :src="TickLightGreen" />
        </div>
        <img :src="mocaIdImg" class="h-60" />
        <p class="text-white text-lg font-semibold">Hi, {{ mocaIdName }}</p>
        <p class="text-moca-white-80 text-base font-normal">View you profile and start earning Realm Points</p>
        <div class="flex flex-row items-center justify-center gap-1">
            <Button class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !rounded-full !px-6"
                @on-click="claimStore.openMocaverseProfilePage">
                View My Profile
            </Button>
        </div>
        <div className="flex flex-row items-center justify-center gap-2 ">
            <p className="text-moca-white-80 text-base font-semibold">
                New account abstraction wallet
            </p>
            <button className="text-white text-sm" @click="claimStore.openContractWalletOnPolygonScan">View Details</button>
        </div>
        <button className="flex flex-row items-center justify-center gap-1" @click="claimStore.openTxOnPolygonScan">
            <img :src="IconPolygonscan" alt="polygonscan" />
            <p className="text-white text-sm leading-4 font-semibold m-0">
                View on Polygonscan
            </p>
        </button>
    </div>
</template>
